import React, { useState } from 'react';
import Address from './Address';
import { GoogleMap, LoadScript, Marker, InfoWindow } from '@react-google-maps/api';
import { GoogleMapsKey, OfficeLocation } from '../../config/Site'
import { Loading } from '@abw/badger-ui';

const Map = () => {
  const [loaded, setLoaded] = useState(false);
  const [info, setInfo] = useState(false);

  return <div className="map">
    <LoadScript googleMapsApiKey={GoogleMapsKey} onLoad={props => setLoaded(true)}>
    { loaded
      ? <GoogleMap
          mapContainerStyle={{ width: '100%', "height": '50vh' }}
          center={OfficeLocation} zoom={11}
        >
          <Marker
            position={OfficeLocation}
            onClick={() => setInfo(! info)}
          />
          { info
            ? <InfoWindow position={OfficeLocation}>
                <div className="smallish black">
                  <Address/>
                </div>
              </InfoWindow>
            : null
          }
        </GoogleMap>
      : <Loading/>
    }
    </LoadScript>
  </div>
}

export default Map